<div class="header">
    <p>Power Users ({{totalRecords}})</p>
    <img src="/assets/icons/Close.svg" alt="close" (click)="closeDialog()" />
</div>
<mat-divider></mat-divider>
<div class="tables-grid curator-list-container">
    <mat-card class="data-table-card">
        <div style="display: flex; align-items: center; padding: 0px 16px; gap: 12px;">
            <div class="position-relative search-input-box">
                <input type="text" placeholder="Search" class="p-8 search-input" style="width: 94%; font-size: 14px;"
                    [(ngModel)]="searchtextData" (ngModelChange)="onSearchChange()" #searchInput>
                <div class="position-absolute search-icon cursor-pointer">
                    <div class="d-flex align-items-center" style="gap: 8px;">
                        <img src="/assets/admin-images/search_cancel_icon.png" style="height: 20px;" alt="search"
                            (click)="clearSearch()" *ngIf="searchtextData">
                        <span style="color: #E1E1EA;" *ngIf="searchtextData">|</span>
                        <img src="/assets/icons/Group 57082.svg" alt="search" (click)="searchData(searchtextData)">
                    </div>
                </div>
            </div>
            <div class="pagination-container">
                <mat-paginator #paginator [length]="totalRecords" [pageSize]="pageSize" [pageIndex]="pageIndex"
                    [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)">
                </mat-paginator>
                <div class="page-dropdown">
                    <mat-select [(ngModel)]="pageIndex" (selectionChange)="onPageChangeFromDropdown($event)">
                        <mat-option *ngFor="let page of pageNumbers" [value]="page" style="font-family: lato, sans-serif;">{{ page + 1 }}</mat-option>
                    </mat-select>
                </div>
            </div>
        </div>

        <table mat-table [dataSource]="dataSource" *ngIf="powerUsersData?.length > 0" aria-label="power users">
            <ng-container matColumnDef="rank">
                <th mat-header-cell *matHeaderCellDef style="width: 15%;">Place</th>
                <td mat-cell *matCellDef="let row">
                    <div style="display: flex; align-items: center;">
                        <img *ngIf="row.rank <= 3; else placeholder" [src]="'/assets/gamification-images/' + (row.rank == 1 ? 'gold_medal.svg' : row.rank == 2 ? 'silver_medal.svg' : 'bronze_medal.svg')" alt="medal" style="width: 20px; height: 20px;margin-right: 8px;" />
                        <ng-template #placeholder>
                        <div style="width: 20px; height: 20px; margin-right: 8px;"></div>
                        </ng-template>
                        <div>{{ row?.rank }}</div>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="username">
                <th mat-header-cell *matHeaderCellDef style="width: 30%;">Name</th>
                <td mat-cell *matCellDef="let row">
                    <div class="ellipsis-text" title="{{ row?.username }}">{{ row?.username }}</div>
                </td>
            </ng-container>
            <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef style="width: 20%;">Role</th>
                <td mat-cell *matCellDef="let row">{{ row?.role }}</td>
            </ng-container>
            <ng-container matColumnDef="prompt_activity">
                <th class="text-ellipsis" title="Prompt Activity" mat-header-cell *matHeaderCellDef style="width: 20%;">Prompt Activity</th>
                <td mat-cell *matCellDef="let row">
                  <div class="single-line-ellipsis" [title]="row?.parsedActivity?.first" *ngIf="row?.parsedActivity?.first">
                    {{ row?.parsedActivity?.first }}
                  </div>
                  <div class="second-line" *ngIf="row?.parsedActivity?.second">
                    <span class="single-line-ellipsis" [title]="row?.parsedActivity?.second">{{ row?.parsedActivity?.second }}</span>
                    <span 
                      *ngIf="row?.parsedActivity?.rest?.length"
                      class="more-count"
                      style="white-space: nowrap;"
                      [matTooltip]="row?.parsedActivity?.rest?.join(', ')">
                      + {{ row?.parsedActivity?.rest?.length }}
                    </span>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="points">
                <th mat-header-cell *matHeaderCellDef style="position: relative; width: 15%;"><span style="margin-right: 10px;">Points</span>
                    <span style="position: absolute; top: 10px;"><img src="/assets/admin-images/up_filled_arrow.svg" alt="up_filled_arrow" (click)="sortingByAsc('points')" *ngIf="pointsAscSort"/></span> 
                    <span style="position: absolute; bottom: 10px;"><img src="/assets/admin-images/down_filled_arrow.svg" alt="down_filled_arrow" (click)="sortingByDes('points')" *ngIf="pointsDesSort"/></span>
                    <span style="position: absolute; top: 10px;"><img src="/assets/admin-images/up_sort_arrow.svg" alt="up_filled_arrow" *ngIf="!pointsAscSort"/></span> 
                    <span style="position: absolute; bottom: 10px;"><img src="/assets/admin-images/down_sort_arrow.svg" alt="down_sort_arrow" *ngIf="!pointsDesSort"/></span>
                </th>
                <td mat-cell *matCellDef="let row">{{ row?.points }}</td>
              </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </table>
        <div *ngIf="powerUsersData?.length <= 0" style="margin: 70px; font-size: 24px; font-weight: 700; text-align: center;">
            No records found.
        </div>
    </mat-card>
</div>
<div style="display: flex;justify-content: center;">
    @if(isLoading){
         <mat-spinner  diameter="40"></mat-spinner>
        }
    </div>